import { useTranslation } from "react-i18next";
import { Calendar } from 'primereact/calendar';

export const DateForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const handleChange = (property, value) => {
        propertyChangeCallback(property, value);
    }

    return (
        <>
            <div className="field-one-columns">
                <div style={{ marginTop: "7px" }}>
                    <label style={{ fontSize: '0.9rem', color: '#666', marginBottom: '4px', display: 'block' }}>
                        {t("NgeDefaultValue")}
                    </label>
                    <Calendar
                        value={field.defaultValue ? new Date(field.defaultValue) : null}
                        onChange={(e) => handleChange("defaultValue", e.value)}
                        dateFormat="dd/mm/yy"
                        disabled={!canEdit}
                        style={{ width: "100%" }}
                    />
                </div>
            </div>
        </>
    )
}